import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const IdentifyEvent = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="identify-event">
        <div className="inner basic-column">
          <div className="title"> {t("identify.identifyEvent.title")}</div>
          <div className="zero-security-card">
            {/* 视频版块 */}
            <div className="zero-security-img">
              {/* <video
                style={{ width: "100%" }}
                autoplay="autoplay"
                loop
                controls
              >
                <source
                  src="https://files.authing.co/authing-website/idenfity-automation-media2.mp4"
                  type="video/mp4"
                  style={{ width: "100%" }}
                ></source>
              </video> */}
              <img
                src="https://files.authing.co/authing-website/idenfity-automation-media.gif"
                alt="authing"
              ></img>
            </div>
            <div className="identify-event-content">
              <div className="title">
                {t("identify.identifyEvent.subtitle1")}
              </div>
              <div className="subtitle">
                {t("identify.identifyEvent.subtitle2")}
              </div>
              <div className="descript-list">
                {t("identify.identifyEvent.descript1")}
              </div>
              <div className="descript-list">
                {t("identify.identifyEvent.descript2")}
              </div>
              <div className="descript-list">
                {t("identify.identifyEvent.descript3")}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
